import { gql } from '@apollo/client';

export const BATCH_IMPORT_ACCESS_CODE = gql`
  mutation BatchImportAccessCode($input: BatchImportAccessCodeInput!) {
    batchImportAccessCode(input: $input) {
      successCount
      failedCount
      totalCount
      failedDetails {
        lineNumber
        errorMessage
        address
      }
    }
  }
`;

export interface BatchImportAccessCodeInput {
  objectKey: string;
}

export interface FailedDetail {
  lineNumber: number;
  errorMessage: string;
  address?: string | null;
}

export interface BatchImportAccessCodeResponse {
  batchImportAccessCode: {
    successCount: number;
    failedCount: number;
    totalCount: number;
    failedDetails: FailedDetail[];
  };
}

